export default function SharedWorker_fn() {
  return new SharedWorker(__webpack_public_path__ + "index_1ae8a5a.worker.js");
}
